import { render, staticRenderFns } from "./Product-v2.vue?vue&type=template&id=83567f00&scoped=true&"
import script from "./Product-v2.vue?vue&type=script&lang=js&"
export * from "./Product-v2.vue?vue&type=script&lang=js&"
import style0 from "./Product-v2.vue?vue&type=style&index=0&id=83567f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83567f00",
  null
  
)

export default component.exports